import React from "react";
import "../css/TransferCertificate.css";

const TransferCertificate = () => {
  return (
    <section className="tc-page">
      <div className="tc-container">
        {}

        <div className="tc-header">
          <span>Sahara Public Secondary School • Nepal</span>

          <h1>Transfer Certificate</h1>

          <p>
            Students and parents can access the official Transfer Certificate
            documents issued by Sahara Public Secondary School.
          </p>
        </div>

        {}

        <div className="tc-card">
          <div className="tc-icon">📄</div>

          <h2>Access Transfer Certificate</h2>

          <p>
            Please click the button below to access the Transfer Certificate
            documents.
          </p>

          <a href="#" className="tc-button">
            Access Certificate
          </a>
        </div>
      </div>
    </section>
  );
};

export default TransferCertificate;
